import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, DispatchCompleteSignIn } from "@insite/client-framework/Store/Context/Handlers/SignIn";

addToChainAfter(chain, DispatchCompleteSignIn, props => {
    const state = props.getState();
    const session = state.context.session;
    const { isAuthenticated, rememberMe, isGuest } = getSession(state);
    const userIsAuthenticated = (isAuthenticated || rememberMe) && !isGuest;
    if (userIsAuthenticated) {
        // Set a flag in sessionStorage to indicate pending GA4 event
        console.info("User is authenticated, setting pendingSignInGA4 flag");
        sessionStorage.setItem("pendingSignInGA4", "true");
        sessionStorage.setItem("signInUserId", session.properties["contactId"] || session.userProfileId || "");
    }
});
